export default __webpack_public_path__ + "static/media/blockIcon.c8ed9830.svg";